import React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../store';
import './HelpTipItem.css';
import {
    helpTipCollapse,
    helpTipExpand,
    helpTipIcon,
} from '../../../img/images';

import { Card } from 'react-bootstrap';
import { IAdminText } from '../../admin/supervisors/interfaces';

interface HelpTipItemProps {
    tip: IAdminText;
    tipKey: string;
}

interface HelpTipItemStates {
    expanded: boolean;
}

class HelpTipItem extends React.Component<HelpTipItemProps, HelpTipItemStates> {
    state = { expanded: false };
    onToggle = () => {
        this.setState({ expanded: !this.state.expanded });
    };
    render = () => {
        return (
            <div
                className={`row help-tip-item ${
                    this.state.expanded
                        ? 'help-tip-item-expanded'
                        : 'help-tip-item-collapse'
                } cursor-pointer`}
                onClick={this.onToggle}
            >
                <div className='help-tip-icon col-1'>
                    <img src={helpTipIcon} alt='help-tip' />
                </div>

                <div className='col-10'>
                    <Card
                        className={`mb-0 ${
                            this.state.expanded ? 'expanded' : ''
                        }`}
                    >
                        <Card.Header>
                            <div className='help-item-title-box txt-overflow'>
                                <div className='help-tip-item-title'>
                                    {this.props.tip.title}
                                </div>
                                <div className='help-tip-item-description txt-overflow'>
                                    {this.props.tip.description}
                                </div>
                            </div>
                        </Card.Header>
                    </Card>
                </div>
                <div className='col-1 help-tips-item-toggle'>
                    {!this.state.expanded ? (
                        <img src={helpTipExpand} alt='' />
                    ) : (
                        <img
                            className='expanded-icon'
                            src={helpTipCollapse}
                            alt=''
                        />
                    )}
                </div>
            </div>
        );
    };
}

const mapStateToProps = (state: RootState) => ({});

export default connect(mapStateToProps, {})(HelpTipItem);
